import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  ActionIcon,
  Badge,
  Button,
  Checkbox,
  Modal,
  Paper,
  Progress,
  Select,
  Text,
  Textarea,
  TextInput,
} from "@mantine/core";
import {
  IconEdit,
  IconFile,
  IconHistory,
  IconHistoryOff,
  IconInfoCircle,
  IconTrash,
} from "@tabler/icons-react";
import file from "./downloadFileLogo.svg";
import { showNotification } from "@mantine/notifications";
import {
  converDateToISO,
  convertToISO8601,
  formatDatetoISO,
  getActFrequencyText,
  getComplianceBadgeColor,
  getDays,
  getDepartmentText,
  getRecFrequencyText,
  getStatusColor,
  getStatusText,
  infoColor,
} from "./utilities";
import BusinessUnitName from "../componenets/getBuName";
import ObligationTranHistoryModal from "./ObligationTranHistoryModal";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../redux/authSlice";
import ActionHistory from "../componenets/actionHistory";
import EvidenceVerificationResult, {
  verificationStatusColor,
} from "../componenets/EvidenceVerificationResult";
import "./common.css";
import { color } from "chart.js/helpers";
import {
  attachFiles,
  attachFileToParent,
  deleteFile,
  getReadUrl,
  updateFileTranId,
} from "../apis/fileApi";
import {
  editObligationApi,
  getObligationDetails,
  getObligationFiles,
  getVerifyEvidenceResult,
  getVerifyEvidenceStatus,
  updateObligationApi,
  verifyEvidence,
} from "../apis/obligationApi";
import axios from "axios";
import { DatePicker } from "@mantine/dates";
import { getCookiesSession } from "../apis/cookiesSession";
// import {fs} from 'fs';
// import {path} from 'path';
const ViewObligation = () => {
  const { id } = useParams();
  const [configs, setConfigs] = useState({
    loading: true,
    obligationData: null,
  });
  const [buttonConfigs, setButtonConfigs] = useState({
    loading: false,
    refresh: false,
  });
  const [ahModal, setAhModal] = useState(false);
  const [ahId, setAhId] = useState(0);
  const [verification, setVerification] = useState({});
  const [resultModal, setResultModal] = useState({ opened: false, fileId: null });
  const dispatch = useDispatch();
  const userData = JSON.parse(getCookiesSession("userData") || "{}");
  const [showEditModal, setShowEditModal] = useState(false);
  const [files, setFiles] = useState([]);
  // Files already covered by an earlier save/history row, so a new save only
  // records evidence uploaded since then (not the whole historical file list).
  const [baselineFileIds, setBaselineFileIds] = useState(new Set());
  // Compliance choice for THIS save - starts empty every time so a Save can
  // never silently reuse the obligation's existing status without the user
  // consciously picking one.
  const [selectedCompliance, setSelectedCompliance] = useState("");
  const [complianceError, setComplianceError] = useState("");
  const [editFiles, setEditFiles] = useState([]);
  useEffect(() => {
    const getObligation = async () => {
      const response = await getObligationDetails({ id: id });
      setConfigs({
        loading: false,
        obligationData: {
          ...response.obligation,
          updatedBy: userData.name,
          remarks: "",
        },
      });
    };
    getObligation();
    const getfiles = async () => {
      const response = await getObligationFiles({ id: id });
      if (response.success) {
        setFiles(response.attachedFiles);
        setBaselineFileIds(new Set(response.attachedFiles.map((f) => f.id)));
        response.attachedFiles.forEach(async (file) => {
          try {
            const resultResp = await getVerifyEvidenceResult({ fileId: file.id });
            if (resultResp.success && resultResp.verification) {
              setVerification((prev) => ({
                ...prev,
                [file.id]: { loading: false, result: resultResp.verification.result },
              }));
            }
          } catch (error) {
            // no stored result yet - not an error the user needs to see
          }
        });
      }
    };
    getfiles();
  }, [id]);

  const uploadFileToAws = async (e) => {
    const file = e.target.files[0];
    const fileSize = file.size;
    const fileName = file.name;

    // Show a placeholder row with a progress bar while the upload is in
    // flight; it's swapped for the real file once the upload completes.
    const tempId = `uploading-${Date.now()}`;
    const placeholder = { id: tempId, fileName: file.name, uploading: true };
    if (showEditModal) {
      setEditFiles((prev) => [...prev, placeholder]);
    } else {
      setFiles((prev) => [...prev, placeholder]);
    }

    const replacePlaceholder = (finalFile) => {
      const swap = (prev) => prev.map((f) => (f.id === tempId ? finalFile : f));
      if (showEditModal) {
        setEditFiles(swap);
      } else {
        setFiles(swap);
      }
    };
    const removePlaceholder = () => {
      const drop = (prev) => prev.filter((f) => f.id !== tempId);
      if (showEditModal) {
        setEditFiles(drop);
      } else {
        setFiles(drop);
      }
    };

    try {
      const response = await attachFileToParent({
        fileName,
        parent: "obligation",
        parentId: id,
      });
      console.log("response for file: ", response);
      const reader = new FileReader();
      console.log("reader : ", reader);
      reader.onload = async () => {
        try {
          const fileData = reader.result;
          const resp = await fetch(`${response.signedUrl}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/octet-stream",
              "Content-Length": fileSize.toString(),
              "Content-Range": `bytes 0-${fileSize - 1}/${fileSize}`,
            },
            body: fileData,
          });
          const result = await resp.json();
          const fileId = result.id;

          console.log("response after upload: ", resp);

          const fileforAttach = {
            createdBy: userData.name,
            createdByUserId: userData.id,
            location: fileId,
            name: file.name,
            parent: "obligation",
            parentId: parseInt(id),
            type: file.type,
          };
          const fileAttached = await attachFiles({ body: fileforAttach });
          console.log(fileAttached.response);
          replacePlaceholder(fileAttached.response);
        } catch (error) {
          console.log("error uploading file: ", error);
          removePlaceholder();
        }
      };
      console.log("came here too");
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.log("error uploading file: ", error);
      removePlaceholder();
    }
  };

  const openFile = async ({ file }) => {
    const hostedLink = file.hostedLink;
    const response = await getReadUrl({ hostedLink });
    console.log("response : ", response);
    if (response.success) {
      window.open(`${response.signedUrl}`, "_blank");
    }
  };
  const deleteFileFromAws = async ({ e, fileId, url }) => {
    e.preventDefault();
    const response = await deleteFile({ id: fileId });
    if (response && response.success) {
      const updatedArray = files.filter((item) => item.id !== fileId);
      setFiles(updatedArray);
    } else {
      showNotification({
        title: "Deletion Failed",
        message: "File deletion failed. Please try again.",
        color: "red",
      });
    }
  };

  const pollVerificationStatus = async (fileId, taskId, deadline) => {
    let statusResp;
    try {
      statusResp = await getVerifyEvidenceStatus({ taskId, fileId, obligationId: id });
    } catch (error) {
      setVerification((prev) => ({
        ...prev,
        [fileId]: { loading: false, error: "Unable to fetch verification status." },
      }));
      return;
    }

    if (statusResp.state === "SUCCESS") {
      const result = statusResp.result && statusResp.result.result;
      setVerification((prev) => ({ ...prev, [fileId]: { loading: false, result } }));
      setResultModal({ opened: true, fileId });
      return;
    }
    if (statusResp.state === "FAILURE") {
      setVerification((prev) => ({
        ...prev,
        [fileId]: { loading: false, error: "Verification failed. Please try again." },
      }));
      return;
    }
    if (Date.now() > deadline) {
      setVerification((prev) => ({
        ...prev,
        [fileId]: { loading: false, error: "Verification is taking longer than expected. Please try again shortly." },
      }));
      return;
    }
    setTimeout(() => pollVerificationStatus(fileId, taskId, deadline), 3000);
  };

  const startEvidenceVerification = async (file) => {
    setVerification((prev) => ({ ...prev, [file.id]: { loading: true } }));
    try {
      const response = await verifyEvidence({ obligationId: id, fileId: file.id });
      if (response.success) {
        pollVerificationStatus(file.id, response.task_id, Date.now() + 90 * 1000);
      } else {
        setVerification((prev) => ({
          ...prev,
          [file.id]: { loading: false, error: response.error || "Unable to start verification." },
        }));
      }
    } catch (error) {
      setVerification((prev) => ({
        ...prev,
        [file.id]: {
          loading: false,
          error:
            (error.response && error.response.data && error.response.data.error) ||
            "Unable to start verification.",
        },
      }));
    }
  };


  const navigate = useNavigate();
  const updateObligation = async (e) => {
    e.preventDefault();
    if (!selectedCompliance) {
      setComplianceError("Please select a compliance status");
      showNotification({
        color: "red",
        title: "Compliance required",
        message: "Please select a compliance status before saving.",
      });
      return;
    }

    // Only evidence uploaded since the last save belongs to this compliance
    // action - not every file ever attached to the obligation.
    let arrayOfIds = files
      .filter((obj) => !baselineFileIds.has(obj.id))
      .map((obj) => obj.id);
    const fileIds = arrayOfIds.join(",");
    let updatedData = {
      ...configs.obligationData,
      compliant: selectedCompliance,
      updatedBy: userData.name,
      donebyId: userData.id,
      donebyEmail: userData.email,
      remarks: configs.obligationData.remarks,
      fileIds,
    };
    const response = await updateObligationApi({
      body: updatedData,
    });
    if (response.success) {
      setBaselineFileIds(new Set(files.map((obj) => obj.id)));
      showNotification({
        color: "green",
        title: "obligation update",
        message: "obligation updated",
      });
      if (
        userData.loginAs === "Ob-DeptAdmin" &&
        userData.loginAs === "Ob-DeptUser"
      ) {
        navigate("/assigned");
      } else {
        navigate("/obligationtracker");
      }
    } else {
      showNotification({
        color: "red",
        title: "obligation update",
        message: "obligation not updated",
      });
    }
  };
  const updateObligationnmi = async (id) => {
    // e.preventDefault();
    let updatedData = {
      ...configs.obligationData,
      extraCol3: id,
      compliant: "partially-compliant",
      updatedBy: userData.name,
      donebyId: userData.id,
      donebyEmail: userData.email,
      remarks: remarks,
    };
    if (id === "2") {
      updatedData = {
        ...configs.obligationData,
        extraCol3: id,
        updatedBy: userData.name,
        donebyId: userData.id,
        donebyEmail: userData.email,
        remarks: remarks,
      };
    }
    if (id === "3") {
      updatedData = {
        ...configs.obligationData,
        extraCol3: id,
        compliant: "compliant",
        updatedBy: userData.name,
        remarks: remarks,
        donebyId: userData.id,
        donebyEmail: userData.email,
      };
    }

    const response = await updateObligationApi({
      body: updatedData,
    });
    console.log(response);
    if (response.success) {
      showNotification({
        color: "green",
        title: "obligation update",
        message: "obligation updated",
      });
      if (
        userData.loginAs === "Ob-DeptAdmin" ||
        userData.loginAs === "Ob-DeptUser"
      ) {
        navigate("/assigned");
      } else {
        navigate("/obligationtracker");
      }
    } else {
      showNotification({
        color: "red",
        title: "obligation update",
        message: "obligation not updated",
      });
    }
  };
  const [showModal, setShowModal] = useState(false);
  const [remarks, setRemarks] = useState("");
  // console.log("files: ", files);
  // console.log("obligation data: ", configs.obligationData);
  const [editData, setEditData] = useState({
    endDate: null,
    remarks: "",
    reminderTime: null,
  });
  const [errors, setErros] = useState({});
  function validate() {
    let keys = {};
    if (!editData.endDate) {
      keys = { ...keys, endDate: "select end date" };
    }
    if (!editData.reminderTime) {
      keys = { ...keys, reminderTime: "select reminder time" };
    }
    if (!editData.remarks) {
      keys = { ...keys, remarks: "enter remarks" };
    }
    if (Object.keys(keys).length === 0) {
      return true;
    } else {
      setErros({ ...keys });
    }
  }
  const editObligation = async () => {
    if (validate()) {
      let arrayOfIds = editFiles.map((obj) => obj.id);
      const fileIds = arrayOfIds.join(",");
      const response = await editObligationApi({
        editData: { ...editData, fileIds, obligationId: id },
      });
      if (response.success) {
        setButtonConfigs({ loading: false, refresh: !buttonConfigs.refresh });
        showNotification({
          message: "Obligation updated",
          color: "green",
          title: "Obligation updated",
        });
        setShowEditModal(false);
      }
    } else {
      setButtonConfigs({ ...buttonConfigs, loading: false });
    }
  };
  console.log("editData: ", editData);
  return (
    <>
      {!configs.loading && configs.obligationData && (
        <>
          {/* <Text className="m-4 font-bold text-md">obligation {id} details</Text> */}
          <Modal
            opened={ahModal}
            onClose={() => {
              setAhModal(false);
              setAhId(0);
            }}
            title="oblligation action history"
            size="calc(80vw)"
          >
            <ObligationTranHistoryModal id={ahId} />
          </Modal>
          <Modal
            opened={resultModal.opened}
            onClose={() => setResultModal({ opened: false, fileId: null })}
            title="AI Evidence Verification Result"
            size="calc(50vw)"
          >
            {resultModal.fileId && verification[resultModal.fileId]?.result && (
              <EvidenceVerificationResult result={verification[resultModal.fileId].result} />
            )}
          </Modal>
          <Modal
            title="Edit Obligation"
            size="calc(60vw)"
            opened={showEditModal}
            onClose={() => setShowEditModal(false)}
          >
            <div className="p-4">
              <div className="grid grid-cols-2 gap-8">
                <DatePicker
                  // className="max-w-lg"
                  required
                  error={errors?.endDate}
                  label="end date"
                  placeholder="Select End Date"
                  value={editData.endDate}
                  onChange={(val) =>
                    setEditData({
                      ...editData,
                      endDate: val ? val.toISOString() : null,
                    })
                  }
                />
                <Select
                  searchable
                  required
                  error={errors?.reminderTime}
                  label="reminder time"
                  // className="max-w-lg"
                  placeholder="Reminder Time"
                  value={editData.reminderTime}
                  data={[
                    { label: "1-day", value: 1 },
                    { label: "2-days", value: 2 },
                    { label: "3-days", value: 3 },
                    { label: "4-days", value: 4 },
                    { label: "5-days", value: 5 },
                    { label: "6-days", value: 6 },
                    { label: "7-days", value: 7 },
                    { label: "15-days", value: 15 },
                    { label: "30-days", value: 30 },
                    { label: "45-days", value: 45 },
                    { label: "60-days", value: 60 },
                    { label: "90-days", value: 90 },
                  ]}
                  onChange={(val) =>
                    setEditData({ ...editData, reminderTime: val })
                  }
                />
              </div>
              <div>
                <Textarea
                  className="mt-4"
                  required
                  error={errors?.remarks}
                  label="Remarks"
                  placeholder="enter remarks here"
                  value={editData.remarks}
                  onChange={(e) =>
                    setEditData({ ...editData, remarks: e.target.value })
                  }
                />
              </div>
              <div>
                <div className="flex items-center justify-center  mt-4">
                  <label
                    htmlFor="dropzone-file"
                    className="flex flex-col items-center justify-center w-full h-34 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                        ariaHidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                        <span>Click to upload</span> or drag and drop
                      </p>
                    </div>
                    <input
                      onChange={async (e) => {
                        await uploadFileToAws(e);
                      }}
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                    />
                  </label>
                </div>
                <div className="mt-2 mb-4">
                  {editFiles?.length > 0 &&
                    editFiles.map((file) => {
                      return (
                        <div
                          key={file.id}
                          className="flex block h-10 mb-4 w-fulll"
                        >
                          <div className="center flex items-center justify-center w-1/12">
                            <svg
                              width="24"
                              height="35"
                              viewBox="0 0 24 35"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14 9.29688V0H1.5C0.66875 0 0 0.731445 0 1.64062V33.3594C0 34.2686 0.66875 35 1.5 35H22.5C23.3312 35 24 34.2686 24 33.3594V10.9375H15.5C14.675 10.9375 14 10.1992 14 9.29688ZM18.0737 24.0632H14V29.5319C14 30.1362 13.5525 30.6257 13 30.6257H11C10.4475 30.6257 10 30.1362 10 29.5319V24.0632H5.92625C5.03375 24.0632 4.58813 22.8813 5.22188 22.1929L11.2481 15.6509C11.6637 15.199 12.335 15.199 12.7506 15.6509L18.7769 22.1929C19.4112 22.8813 18.9662 24.0632 18.0737 24.0632ZM23.5625 7.17773L17.4438 0.478516C17.1625 0.170898 16.7812 0 16.3813 0H16V8.75H24V8.33301C24 7.90234 23.8438 7.48535 23.5625 7.17773Z"
                                fill="#191D23"
                              />
                            </svg>
                          </div>
                          <div className="flex flex-col pl-3 w-full">
                            <div className="flex flex-row justify-between">
                              <div
                                style={{
                                  lineHeight: "1.25rem",
                                  letterSpacing: "-0.0313rem",
                                  color: "#191D23",
                                }}
                              >
                                <Text className="font-normal">
                                  {file.fileName}
                                </Text>
                              </div>
                            </div>
                            <div className="mt-3">
                              <Progress
                                color={file.errored ? "red" : "teal"}
                                size="sm"
                                // animate={
                                //   file.fetchingUploadUrl ||
                                //   file.attaching === loadingStates.LOADING
                                // }
                                // value={
                                //   file.fetchingUploadUrl || file.errored
                                //     ? 100
                                //     : file.uploadPercentage
                                // }
                                value={100}
                              />
                            </div>
                          </div>
                          <div className="center inline-block">
                            <Button
                              // onClick={downloadFile(index)}
                              className="mx-3 w-60"
                              color="#1b6f8d"
                              // disabled={file.downloading === loadingStates.LOADING}
                              // classNames={`${styles.btn} mx-3`}
                              variant="outline"
                              style={{
                                color: "#1b6f8d",
                                borderColor: "#1b6f8d",
                              }}
                              onClick={() => openFile({ file: file })}
                            >
                              Open
                            </Button>
                          </div>
                          {(userData.loginAs === "Ob-DeptAdmin" ||
                            userData.loginAs === "Ob-DeptUser") && (
                            <div className="center w-1/12 px-auto py-auto inline-block">
                              <IconTrash
                                onClick={(e) =>
                                  deleteFileFromAws({
                                    e: e,
                                    fileId: file.id,
                                    url: file.hostedLink,
                                  })
                                }
                                className="mx-auto"
                                size={30}
                                color="#1b6f8d"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="flex justify-between mt-6">
                <Button onClick={() => setShowEditModal(false)} color="#1b6f8d">
                  Cancel
                </Button>
                <Button
                  loading={buttonConfigs.loading}
                  onClick={() => {
                    setButtonConfigs({ ...buttonConfigs, loading: true });
                    editObligation();
                  }}
                  variant="outline"
                >
                  Save
                </Button>
              </div>
            </div>
          </Modal>
          {!configs.loading && (
            <>
              <div
                className="flex justify-between items-start mx-4 mt-2 pb-4"
                style={{ borderBottom: "1px solid #e5e9eb" }}
              >
                <div>
                  <Text size="xl" weight={700} style={{ color: "#191D23" }}>
                    Obligation-{id}
                  </Text>
                  <Text size="sm" className="mt-1">
                    <span className="blue font-medium">Created On: </span>
                    {formatDatetoISO(configs.obligationData.startDate)}
                  </Text>
                </div>
                <div className="flex flex-col items-end">
                  <div className="flex items-center">
                    {configs.obligationData.compliant === "delayed-compliant" ||
                    configs.obligationData.compliant === "compliant" ? null : (
                      <Badge
                        variant="light"
                        color={getStatusColor(configs.obligationData.status)}
                      >
                        {getStatusText(configs.obligationData.status)}
                      </Badge>
                    )}
                    <div className="flex flex-row ml-4 item-center">
                      <ActionIcon
                        onClick={() => {
                          setAhId(id);
                          setAhModal(true);
                        }}
                        color="white"
                      >
                        <IconHistory size={20} />
                      </ActionIcon>
                      {userData.loginAs === "Ob-DeptAdmin" &&
                        configs.obligationData.actFrequency === 1 && (
                          <ActionIcon
                            onClick={() => setShowEditModal(true)}
                            color="white"
                          >
                            <IconEdit variant="light" size={20} />
                          </ActionIcon>
                        )}
                    </div>
                  </div>
                  {configs.obligationData.compliant === "delayed-compliant" ||
                  configs.obligationData.compliant === "compliant" ? null : (
                    <Text size="sm" className="mt-1" color="dimmed">
                      Pending since {getDays(configs.obligationData.startDate)} day(s)
                    </Text>
                  )}
                </div>
              </div>
              <Paper withBorder radius="md" p="md" className="mx-4 mt-6">
                <Text
                  className="font-semibold mb-4"
                  style={{ color: "#1b6f8d", letterSpacing: "0.03em" }}
                >
                  CONTRACT DETAILS
                </Text>
                <div className="grid grid-cols-4 gap-6 text-left">
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Department
                    </Text>
                    <Text className="font-medium mt-1">
                      {getDepartmentText(configs.obligationData.department)}
                    </Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      AIN
                    </Text>
                    <Text className="font-medium mt-1">
                      {configs.obligationData.local && "local-"}
                      {configs.obligationData.connectedAgreement}
                    </Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Job Order
                    </Text>
                    <Text className="font-medium mt-1">{configs.obligationData.joOrder}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Brand Name
                    </Text>
                    <Text className="font-medium mt-1">{configs.obligationData.brandName}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Contract Category
                    </Text>
                    <Text className="font-medium mt-1">{configs.obligationData.extraCol1}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Business Unit
                    </Text>
                    <Text className="font-medium mt-1">
                      <BusinessUnitName
                        businessUnitId={configs.obligationData.businessUnit}
                      />
                    </Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Connected Party
                    </Text>
                    <Text className="font-medium mt-1">{configs.obligationData.connectedParty}</Text>
                  </div>
                </div>
              </Paper>
              <Paper withBorder radius="md" p="md" className="mx-4 mt-4">
                <Text
                  className="font-semibold mb-4"
                  style={{ color: "#1b6f8d", letterSpacing: "0.03em" }}
                >
                  OBLIGATION DETAILS
                </Text>
                <div className="grid grid-cols-4 gap-6 text-left">
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Clause Number
                    </Text>
                    <Text className="font-medium mt-1">{configs.obligationData.clNo}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Title
                    </Text>
                    <Text className="font-medium mt-1">{configs.obligationData.title}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Obligation
                    </Text>
                    <Text className="font-medium mt-1">{configs.obligationData.desc}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Assigned To
                    </Text>
                    <Text className="font-medium mt-1">{configs.obligationData.assignTo.name}</Text>
                  </div>

                  {configs.obligationData.actFrequency !== 1 && (
                    <div>
                      <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                        Rec. Frequency
                      </Text>
                      <Text className="font-medium mt-1">
                        {getRecFrequencyText(configs.obligationData.recFrequency)}
                      </Text>
                    </div>
                  )}

                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Act. Frequency
                    </Text>
                    <Text className="font-medium mt-1">
                      {getActFrequencyText(configs.obligationData.actFrequency)}
                    </Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Reminder Time
                    </Text>
                    <Text className="font-medium mt-1">
                      {configs.obligationData.reminderTime}-days
                    </Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Due Date
                    </Text>
                    <Text className="font-medium mt-1">
                      {formatDatetoISO(configs.obligationData.duedate)}
                    </Text>
                  </div>
                </div>
              </Paper>
              <Paper withBorder radius="md" p="md" className="mx-4 mt-4">
                <Text
                  className="font-semibold mb-2"
                  style={{ color: "#1b6f8d", letterSpacing: "0.03em" }}
                >
                  AUDIT HISTORY
                </Text>
                <ActionHistory
                  refresh={buttonConfigs.refresh}
                  openFile={openFile}
                  id={id}
                />
              </Paper>
              <Paper withBorder radius="md" p="md" className="mx-4 mt-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="w-1/2">
                  {userData.loginAs === "Ob-DeptAdmin" ||
                  userData.loginAs === "Ob-DeptUser" ? (
                    <Select
                      label="compliance"
                      placeholder="Select compliance status"
                      required
                      error={complianceError}
                      value={selectedCompliance}
                      onChange={(val) => {
                        setSelectedCompliance(val);
                        setComplianceError("");
                      }}
                      data={
                        new Date() > new Date(configs.obligationData?.duedate)
                          ? [
                              {
                                label: "Non-Compliant",
                                value: "non-compliant",
                              },
                              {
                                label: "Partially-Compliant",
                                value: "partially-compliant",
                              },
                              {
                                label: "Delayed-Compliant",
                                value: "delayed-compliant",
                              },
                            ]
                          : [
                              {
                                label: "Non-Compliant",
                                value: "non-compliant",
                              },
                              {
                                label: "Partially-Compliant",
                                value: "partially-compliant",
                              },
                              { label: "Compliant", value: "compliant" },
                            ]
                      }
                    />
                  ) : (
                    <div>
                      <Text className="font-normal blue">compliance : </Text>
                      <Text
                        color={getComplianceBadgeColor(
                          configs.obligationData.compliant
                        )}
                      >
                        {configs.obligationData.compliant}
                      </Text>
                    </div>
                  )}
                </div>
                <div>
                  <div>
                    <Textarea
                      rows={2}
                      type="text"
                      placeholder="Remark"
                      className="mx-2"
                      value={configs.obligationData.remarks}
                      onChange={(e) =>
                        setConfigs({
                          ...configs,
                          obligationData: {
                            ...configs.obligationData,
                            remarks: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                </div>
                </div>
              </Paper>
            </>
          )}

          <Paper withBorder radius="md" p="md" className="mx-4 mt-4">
          <Text
            className="font-semibold mb-2"
            style={{ color: "#1b6f8d", letterSpacing: "0.03em" }}
          >
            EVIDENCE
          </Text>
          {(userData.loginAs === "Ob-DeptAdmin" ||
            userData.loginAs === "Ob-DeptUser") && (
            <div className="flex items-center justify-center  m-4">
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-34 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    ariaHidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span>Click to upload</span> or drag and drop
                  </p>
                </div>
                <input
                  onChange={async (e) => {
                    await uploadFileToAws(e);
                  }}
                  id="dropzone-file"
                  type="file"
                  className="hidden"
                />
              </label>
            </div>
          )}
          <div className="m-4">
            {files?.length > 0 &&
              files.map((file) => {
                if (file.uploading) {
                  return (
                    <div
                      key={file.id}
                      className="flex flex-col justify-center mb-3 w-full p-3 rounded-lg bg-white"
                      style={{ border: "1px solid #e5e9eb" }}
                    >
                      <Text className="font-normal" style={{ color: "#191D23" }}>
                        {file.fileName}
                      </Text>
                      <div className="mt-2">
                        <Progress color="teal" size="sm" value={100} animate />
                      </div>
                    </div>
                  );
                }
                return (
                  <div
                    key={file.id}
                    className="flex items-center mb-3 w-full p-3 rounded-lg bg-white"
                    style={{ border: "1px solid #e5e9eb" }}
                  >
                    <div className="flex items-center justify-center w-1/12">
                      <svg
                        width="20"
                        height="29"
                        viewBox="0 0 24 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14 9.29688V0H1.5C0.66875 0 0 0.731445 0 1.64062V33.3594C0 34.2686 0.66875 35 1.5 35H22.5C23.3312 35 24 34.2686 24 33.3594V10.9375H15.5C14.675 10.9375 14 10.1992 14 9.29688ZM18.0737 24.0632H14V29.5319C14 30.1362 13.5525 30.6257 13 30.6257H11C10.4475 30.6257 10 30.1362 10 29.5319V24.0632H5.92625C5.03375 24.0632 4.58813 22.8813 5.22188 22.1929L11.2481 15.6509C11.6637 15.199 12.335 15.199 12.7506 15.6509L18.7769 22.1929C19.4112 22.8813 18.9662 24.0632 18.0737 24.0632ZM23.5625 7.17773L17.4438 0.478516C17.1625 0.170898 16.7812 0 16.3813 0H16V8.75H24V8.33301C24 7.90234 23.8438 7.48535 23.5625 7.17773Z"
                          fill="#191D23"
                        />
                      </svg>
                    </div>
                    <div className="flex items-center pl-3 w-full">
                      <Text
                        className="font-normal"
                        style={{
                          lineHeight: "1.25rem",
                          letterSpacing: "-0.0313rem",
                          color: "#191D23",
                        }}
                      >
                        {file.fileName}
                      </Text>
                    </div>
                    <div className="flex items-center justify-center">
                      <Button
                        className="mx-3 w-60"
                        color="#1b6f8d"
                        variant="outline"
                        style={{
                          color: "#1b6f8d",
                          borderColor: "#1b6f8d",
                        }}
                        onClick={() => openFile({ file: file })}
                      >
                        Open
                      </Button>
                    </div>
                    <div className="flex flex-col items-center justify-center">
                      {verification[file.id]?.result ? (
                        <Badge
                          className="cursor-pointer"
                          size="lg"
                          color={verificationStatusColor(verification[file.id].result.status)}
                          onClick={() => setResultModal({ opened: true, fileId: file.id })}
                        >
                          {verification[file.id].result.status}
                        </Badge>
                      ) : (
                        <Button
                          className="mx-3 w-60"
                          color="#5689C0"
                          variant="outline"
                          style={{ color: "#5689C0", borderColor: "#5689C0" }}
                          loading={verification[file.id]?.loading}
                          onClick={() => startEvidenceVerification(file)}
                        >
                          Verify Evidence
                        </Button>
                      )}
                      {verification[file.id]?.error && (
                        <Text className="mt-1 text-xs text-center" color="red">
                          {verification[file.id].error}
                        </Text>
                      )}
                    </div>
                    {(userData.loginAs === "Ob-DeptAdmin" ||
                      userData.loginAs === "Ob-DeptUser") && (
                      <div className="flex items-center justify-center w-1/12">
                        <IconTrash
                          onClick={(e) =>
                            deleteFileFromAws({
                              e: e,
                              fileId: file.id,
                              url: file.hostedLink,
                            })
                          }
                          className="cursor-pointer"
                          size={26}
                          color="#1b6f8d"
                        />
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
          </Paper>

          {/* //updating the oblligation */}
          <div className="flex mt-6 justify-center items-center gap-4">
            {(userData.loginAs === "Ob-DeptAdmin" ||
              userData.loginAs === "Ob-DeptUser") &&
              configs.obligationData.extraCol3 !== "1" && (
                <Button
                  onClick={(e) => {
                    setConfigs({
                      ...configs,
                      obligationData: {
                        ...configs.obligationData,
                        updatedBy: userData.name,
                      },
                    });
                    updateObligation(e);
                  }}
                  color="#1a73e8"
                  style={{
                    width: "150px",
                    backgroundColor: "#1b6f8d",
                  }}
                >
                  Save
                </Button>
              )}
            {/* submit nmi info */}
            {(userData.loginAs === "Ob-DeptAdmin" ||
              userData.loginAs === "Ob-DeptUser") &&
              configs.obligationData.extraCol3 === "1" && (
                <Button
                  onClick={(e) => {
                    setShowModal(true);
                  }}
                  color="#1a73e8"
                  style={{ width: "150px" }}
                >
                  Submit Info
                </Button>
              )}
            {/* need more infor on home page */}
            {["Ob-Admin", "Ob-DeptAdmin", "Ob-CEO"].includes(userData.loginAs) &&
              configs.obligationData.extraCol3 === "" && (
                <Button
                  onClick={async (e) => {
                    setShowModal(true);
                  }}
                  style={{ width: "150px", backgroundColor: "#1b6f8d" }}
                >
                  Need More Info
                </Button>
              )}
            {/* accept info on home page */}
            {(userData.loginAs === "Ob-Admin" ||
              userData.loginAs === "Ob-DeptAdmin" ||
              userData.loginAs === "Ob-CEO") &&
              configs.obligationData.extraCol3 === "2" && (
                <Button
                  onClick={async (e) => {
                    setShowModal(true);
                  }}
                  variant="outline"
                  style={{ width: "200px" }}
                >
                  Need More Information
                </Button>
              )}

            {/* disabled info submitted button */}
            {(userData.loginAs === "Ob-Admin" ||
              userData.loginAs === "Ob-DeptAdmin" ||
              userData.loginAs === "Ob-Auditor") &&
              configs.obligationData.extraCol3 === "3" && (
                <Button variant="outline" style={{ width: "180px" }}>
                  Information Submitted
                </Button>
              )}
          </div>
          <Modal
            title="Need More Info"
            size="md"
            radius="md"
            onClose={() => setShowModal(false)}
            opened={showModal}
          >
            <Text size="sm" className="blue font-medium mb-1">
              Remarks
            </Text>
            <Textarea
              minRows={5}
              placeholder="Enter remark..."
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
            />

            {(userData.loginAs === "Ob-DeptAdmin" ||
              userData.loginAs === "Ob-DeptUser") &&
              configs.obligationData.extraCol3 === "1" && (
                <div className="flex mt-6 justify-end gap-3">
                  <Button
                    variant="outline"
                    style={{ color: "#1b6f8d", borderColor: "#1b6f8d" }}
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="#1b6f8d"
                    onClick={() => updateObligationnmi("2")}
                  >
                    Submit
                  </Button>
                </div>
              )}

            {(userData.loginAs === "Ob-Admin" ||
              userData.loginAs === "Ob-DeptAdmin" ||
              userData.loginAs === "Ob-Auditor") && (
              <div className="flex mt-6 justify-end gap-3">
                {configs.obligationData.extraCol3 === "2" && (
                  <>
                    <Button
                      variant="outline"
                      style={{ color: "#1b6f8d", borderColor: "#1b6f8d" }}
                      onClick={() => updateObligationnmi("1")}
                    >
                      Need More Info
                    </Button>
                    <Button
                      color="#1b6f8d"
                      onClick={() => updateObligationnmi("3")}
                    >
                      Accept Info
                    </Button>
                  </>
                )}

                {configs.obligationData.extraCol3 === "" && (
                  <>
                    <Button
                      variant="outline"
                      style={{ color: "#1b6f8d", borderColor: "#1b6f8d" }}
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      color="#1b6f8d"
                      onClick={() => {
                        updateObligationnmi("1");
                      }}
                    >
                      Need More Info
                    </Button>
                  </>
                )}
              </div>
            )}
          </Modal>
        </>
      )}
    </>
  );
};

export default ViewObligation;
